import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.MAGAZINE_ARTICLES_FETCH_SUCCESS,
    actions.MAGAZINE_ARTICLES_RECEIVED,
    actions.MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS,
    actions.MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS
  ],
  updateSuccessTypes: [actions.MAGAZINE_ARTICLE_UPDATE],
  updateKey: 'magazineArticleId',
  entityType: 'magazineArticles'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/magazineArticles/byId/reducer.js
 **/